import React from 'react';
export const useWindowWidth = () => {
    const [contentWidth, setContentWidth] = React.useState(document.body.getBoundingClientRect().width);
    React.useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            setContentWidth(entries[0].contentRect.width);
        });
        observer.observe(document.body);
        return () => observer.disconnect();
    }, []);
    return contentWidth;
};
//# sourceMappingURL=useWindowWidth.preenvesnextjs.map
